import template from './tc-document-menu.html';
import './tc-document-menu.scss';
import _ from 'lodash';

export default angular
  .module('doxy.common.components.tcDocumentMenu', [])
  .component('tcDocumentMenu', {
    //tc-document-menu
    template,
    bindings: {
      disabled: '<?',
      document: '<',
      hideTitle: '<',
    },
    controller: function ($rootScope) {
      this.$onInit = () => {
        // Ensure document and metadata are available before accessing them
        if (!this.document || !this.document.metadata || !this.document.metadata.pages) {
          console.warn('TcDocumentMenu: document, metadata, or pages not available');
          return;
        }

        this.currentIndex = 0;
        this.pages = this.document.metadata.pages;
        this.lastPageIndex = this.pages.length - 1;
      };

      this.onClose = () => {
        $rootScope.$emit('tcDocument:closeShare');
      };

      this.toIndex = (index) => {
        if (this.disabled) return;

        this.currentIndex = index;
        $rootScope.$emit('tcDocument:menu:get', this.currentIndex);
      };

      const cleanMenuSetUpListener = $rootScope.$on(
        'tcDocument:menu:set',
        (_event, index) => {
          this.currentIndex = index;
        }
      );

      this.finalize = () => {
        this.finalizePromise = this.document.finalizePages();
      };

      this.$onDestroy = () => {
        cleanMenuSetUpListener();
      };

      this.getPageTitle = (page, index) => {
        const title =
          _.get(page, 'elements[0].title') || _.get(page, 'elements[0].text');
        if (!title) return 'Page ' + (index + 1);
        return title.replace(/<[^>]+>/g, '').substr(0, 50);
      };
    },
  }).name;
